module.exports = __webpack_public_path__ + "images/061ecb9221a3ec8e04476879bced56f5c3e3e602ca22b1b7b2f02c7fed414f58.svg";